export const GET_CURRENT_PROPERTY = "GET_CURRENT_PROPERTY";
export const RESET_CURRENT_PROPERTY = "RESET_CURRENT_PROPERTY";
export const SET_CURRENT_PROPERTY_REQUEST_STATUS = "SET_CURRENT_PROPERTY_REQUEST_STATUS";
